import {
  Input,
  Output,
  EventEmitter,
  Component,
  forwardRef,
  HostListener,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { NgpSwitch, NgpSwitchThumb } from 'ng-primitives/switch';
import { NgpFocus } from 'ng-primitives/interactions';

import {
  SuiFormFieldControl,
  SUI_FORM_FIELD_CONTROL,
} from '../form-field/form-field-control';
import { SuiFormControlBase } from '../shared/cva-helper';

@Component({
  selector: 'sui-switch',
  standalone: true,
  imports: [NgpSwitch, NgpSwitchThumb, NgpFocus],
  templateUrl: './sui-switch.component.html',
  styleUrl: './sui-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SuiSwitchComponent),
      multi: true,
    },
    {
      provide: SUI_FORM_FIELD_CONTROL,
      useExisting: forwardRef(() => SuiSwitchComponent),
    },
  ],
})
export class SuiSwitchComponent
  extends SuiFormControlBase<boolean>
  implements SuiFormFieldControl
{
  private static _idCounter = 0;
  private readonly _uid = `sui-switch-${++SuiSwitchComponent._idCounter}`;
  private _focused = false;

  readonly controlType = 'switch';

  @Input() id = '';

  @Output() checkedChange = new EventEmitter<boolean>();

  @Input()
  set checked(val: boolean) {
    this.value.set(val);
  }

  @Input()
  set disabled(val: boolean) {
    this.setDisabledState(val);
  }
  get disabled(): boolean {
    return this.isDisabled();
  }

  get effectiveId(): string {
    return this.id || this._uid;
  }

  get isChecked(): boolean {
    return !!this.value();
  }

  get focused(): boolean {
    return this._focused;
  }

  get empty(): boolean {
    return !this.value();
  }

  get errorState(): boolean {
    return !!(this.ngControl?.invalid && this.ngControl?.touched);
  }

  @HostListener('focusin')
  onFocusIn(): void {
    this._focused = true;
  }

  @HostListener('focusout')
  onFocusOut(): void {
    this._focused = false;
  }

  onCheckedChange(checked: boolean): void {
    this.setValue(checked);
    this.checkedChange.emit(checked);
  }
}
